import { drawingStore } from "../store";

export const removeDrawingFromLocalState = (id: string) => {
  const store = drawingStore.reduxStore?.store;
  if (!store) return;

  store.dispatch({
    type: "drawings/delete-drawing",
    payload: { drawingId: id },
  });
};
